export const getMovementsEndpoint =
  '/movimenti-conto-ms/ms/account/movements/transactions';

// return movements Lotterie as TabListMovements 9'.
export const getLotteryEndpoint =
  '/movimenti-conto-ms/ms/account/movements/getGntnPlayList';

// return movements 'Operazioni Prenotate' as TabListMovements 16'.
export const getBookingOperationsEndpoint =
  '/movimenti-conto-ms/ms/account/movements/getBookingOperations';

// return movements 'Gratta e Vinci' as TabListMovements 6'.
export const getLitPlayListEndpoint =
  '/movimenti-conto-ms/ms/account/movements/getLitPlayList';

export const getTicketTotocalcioEndpoint =
  '/movimenti-conto-ms/ms/account/movements/getTicketTotocalcio';
